import { LocalDictionaryFactory } from '../../api/api.module';
import { LoggerService } from '../../common/common.module';
import { DEVICE_SERVICE_NAME, DeviceService } from '../../../services/device'
import { SCHEMA_SERVICE_NAME, SchemaService } from '../../../services/schema'
import { DevicesDetailsDirectiveController } from './devices-details.directive.controller';
import { SystemService, $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME } from '../../../services/system';
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session';

//#region Asset Imports

import './devices-details.scss'
import * as TEMPLATE from './devices-details.tpl.html'

//#endregion

// Setup

export class DevicesDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'logger',
        'localDictionary',
        SYSTEM_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        DEVICE_SERVICE_NAME, SCHEMA_SERVICE_NAME, (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            systemService: SystemService,
            userSession: UserSessionService,
            deviceService: DeviceService,
            schemaService: SchemaService
        ) => new DevicesDetailsDirectiveController(
            $scope,
            $q,
            $timeout,
            logger,
            localDictionary,
            systemService,
            userSession,
            DeviceService.REFERENCE_TYPE,
            DeviceService.SIMAX_MODULE_NAME,
            deviceService,
            schemaService
        )]

    template = TEMPLATE
}

// Setup End